export default "__VITE_ASSET__Ziodm_$l__"